/* eslint-disable css-modules/no-unused-class */
import { Fragment, memo, useCallback, useEffect, useMemo } from "react";
import { AdUnitsKeys, units } from "./config/units";
import { useDeviceType } from "@/common/hooks/useDeviceType";
import { deviceTypeEnum } from "@/common/utils/device";
import { isDisableAds } from "./utils";
import { useGetAdSlots } from "./hooks/useGetAdSlots";
import classes from "./AdUnit.module.scss";
import { addAdvertisment } from "@/components/ads/goCtrl";

export enum AdUnitTypeEnum {
  MOBILE = "Mobile",
  DESKTOP = "Desktop"
}

interface AdUnitProps {
  name: AdUnitsKeys;
  type: AdUnitTypeEnum;
}

const AdUnit = memo(({ name, type }: AdUnitProps) => {
  const isDesktop = useDeviceType() === deviceTypeEnum.DESKTOP;
  const { slots, error, isLoading } = useGetAdSlots();

  const code = units[name];
  const id = code.display ?? `sp_${code.sid}`;

  const isDisabledSlot = useMemo(() => {
    if (isLoading) {
      return true;
    }

    if (error) {
      return false;
    }

    if (slots === null) {
      return true;
    }

    return slots.indexOf(name) === -1;
  }, [slots, isLoading, error, name]);

  const addCode = useCallback(() => {
    const { ...goCtrlCode } = code;
    goCtrlCode.display = id;
    goCtrlCode.style = undefined;

    addAdvertisment(goCtrlCode);
  }, [code, id]);

  useEffect(() => {
    if (isDisableAds() || isDisabledSlot) {
      return;
    }

    addCode();
  }, [addCode, isDisabledSlot]);

  if (isDisabledSlot) {
    return null;
  }

  const containerClass = `bannerWrapper ${classes.bannerWrapper} ${code.className ? classes[code.className] : ""}`.trim();

  return (
    <Fragment>
      {((isDesktop && type === AdUnitTypeEnum.DESKTOP) || (!isDesktop && type === AdUnitTypeEnum.MOBILE)) && (
        <div className={containerClass} style={code.style}>
          <div className={classes.adBox} id={id} />
        </div>
      )}
    </Fragment>
  );
});

export default AdUnit;
